export default __webpack_public_path__ + "static/media/ESIC.4d20e4dd.jpeg";